export default [
    {
        path: '/(uk/|ru/)?/dashboard/company-manangment',
        redirect:'/(uk/|ru/)?/dashboard/company-manangment/park',
        name: 'Company',
        component: () => import('../views/cabinet/company/Company'),
        query: true,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '/(uk/|ru/)?/dashboard/company-manangment/park',
                name: 'CompanyPark',
                component: () => import('../views/cabinet/company/tabs/CompanyPark'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/role',
                name: 'CompanyRole',
                component: () => import('../views/cabinet/company/tabs/CompanyRole'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/user',
                name: 'CompanyUser',
                component: () => import('../views/cabinet/company/tabs/CompanyUser'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/department',
                name: 'CompanyDepartment',
                component: () => import('../views/cabinet/company/tabs/CompanyDepartment'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/provider',
                name: 'CompanyPaymentProvider',
                component: () => import('../views/cabinet/company/tabs/CompanyPaymentProvider'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/source-payment-provider',
                name: 'CompanySourcePaymentProvider',
                component: () => import('../views/cabinet/company/tabs/CompanySourcePaymentProvider'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/payment-config-and-commission',
                name: 'CompanyPaymentConfigAndCommission',
                component: () => import('../views/cabinet/company/tabs/CompanyPaymentConfigAndCommission'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/provider-service',
                name: 'CompanyProviderService',
                component: () => import('../views/cabinet/company/tabs/CompanyProviderService'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/chat-platform',
                name: 'CompanyChatPlatform',
                component: () => import('../views/cabinet/company/tabs/CompanyChatPlatform'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/application-instance',
                name: 'CompanyApplicationInstance',
                component: () => import('../views/cabinet/company/tabs/CompanyApplicationInstance'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting',
                component: () => import('../views/cabinet/company/tabs/CompanyApplicationManagement'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
                children: [{
                    path: '',
                    name: 'CompanyApplicationManagement',
                    component: () => import('../views/cabinet/company/tabs/CompanyApplicationManagement/General.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/revision',
                    name: 'CompanyApplicationManagementRevision',
                    component: () => import('../views/cabinet/company/tabs/CompanyApplicationManagement/Revision.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/revision/form',
                    name: 'CompanyApplicationManagementRevisionForm',
                    component: () => import('../views/cabinet/company/tabs/CompanyApplicationManagement/RevisionForm.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/oferta',
                    name: 'CompanyApplicationManagementRevisionOfertaList',
                    component: () => import('../views/cabinet/company/tabs/CompanyApplicationManagement/OfertaList.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/aboutus',
                    name: 'CompanyApplicationManagementAboutus',
                    component: () => import('../views/cabinet/company/tabs/CompanyApplicationManagement/aboutus.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/oferta/edit/:id',
                    name: 'CompanyApplicationManagementRevisionOferta',
                    component: () => import('../views/cabinet/company/tabs/CompanyApplicationManagement/Oferta.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/oferta/create',
                    name: 'CompanyApplicationManagementRevisionOfertaCreate',
                    component: () => import('../views/cabinet/company/tabs/CompanyApplicationManagement/Oferta.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/application-setting/translate',
                    name: 'CompanyApplicationManagementRevisionTranslate',
                    component: () => import('../views/cabinet/company/tabs/CompanyApplicationManagement/Translate.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка приложения'
                    },
                }]
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/team-settings',
                component: () => import('../views/cabinet/company/tabs/CompanyTeamSetting'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настройка Бригад'
                },
                children: [{
                    path: '',
                    name: 'CompanyTeamSettingworkRule',
                    component: () => import('../views/cabinet/company/tabs/CompanyTeamSetting/WorkRule.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Условия работы Бригад'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/team-settings/settings',
                    name: 'CompanyTeamSetting',
                    component: () => import('../views/cabinet/company/tabs/CompanyTeamSetting/Settings.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройка Бригад'
                    },
                },]
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/overdraft',
                name: 'CompanyOverdraft',
                component: () => import('../views/cabinet/company/tabs/CompanyOverdraft'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Офердрафт'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/spands',
                name: 'CompanySpends',
                component: () => import('../views/cabinet/company/tabs/CompanySpends'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление компанией'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/ie',
                component: () => import('../views/cabinet/company/tabs/CompanyIe'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настройки ИП'
                },
                children: [{
                    path: '',
                    name: 'CompanyIe',
                    component: () => import('../views/cabinet/company/tabs/CompanyIe/Main.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, основные'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/ie/output-blocking',
                    name: 'CompanyIeOutputBlocking',
                    component: () => import('../views/cabinet/company/tabs/CompanyIe/OutputBlocking.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, Sigex подпись'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/ie/sigex',
                    name: 'CompanyIeSigex',
                    component: () => import('../views/cabinet/company/tabs/CompanyIe/Sigex.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, Sigex подпись'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/ie/Sapar',
                    name: 'CompanyIeSapar',
                    component: () => import('../views/cabinet/company/tabs/CompanyIe/Sapar.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, Sigex подпись'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/ie/payda',
                    name: 'CompanyIePayda',
                    component: () => import('../views/cabinet/company/tabs/CompanyIe/Payda.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, Sigex подпись'
                    },
                }, {
                    path: '/(uk/|ru/)?/dashboard/company-manangment/ie/contract',
                    name: 'CompanyIeContract',
                    component: () => import('../views/cabinet/company/tabs/CompanyIe/CompanyIeContract.vue'),
                    query: true,
                    meta: {
                        requiresAuth: true,
                        title: 'Настройки ИП, Контракты'
                    },
                },]
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/employee-contractor',
                name: 'CompanyEmployeeContractor',
                component: () => import('../views/cabinet/company/tabs/EmployeeContractor/List.vue'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Договор сотрудничества'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/settings',
                name: 'CompanyOtherSettings',
                component: () => import('../views/cabinet/company/tabs/OtherSettings'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Прочее'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/contracts',
                name: 'CompanyContractorsPayoutParks',
                component: () => import('../views/cabinet/company/tabs/CompanyContractorsPayoutParks'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Прочее'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/referral-settings',
                name: 'CompanyReferralSettings',
                component: () => import('../views/cabinet/company/tabs/CompanyReferralSettings'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настроки реферальной программы'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/wolt-agreement',
                name: 'CompanyWoltCooperationAgreement',
                component: () => import('../views/cabinet/company/tabs/CompanyWoltCooperationAgreement'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настроки реферальной программы'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/telephony',
                name: 'CompanyTelephonySettings',
                component: () => import('../views/cabinet/company/tabs/CompanyTelephonySettings'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Настроки реферальной программы'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/company-manangment/iron-park-agreement',
                name: 'CompanyIronParkAgreement',
                component: () => import('../views/cabinet/company/tabs/IronParkAgreement'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Договор аренды'
                },
            },]
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ai',
        component: () => import('../views/cabinet/company/tabs/CompanyAISettings'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Настройки ИИ'
        },
        children: [{
            path: '',
            name: 'CompanyAISettings',
            component: () => import('../views/cabinet/company/tabs/aisettings/index.vue'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Настройки ИИ, основные'
            },
        }, {
            path: '/(uk/|ru/)?/dashboard/company-manangment/ai/promo',
            name: 'CompanyAISettingsPromo',
            component: () => import('../views/cabinet/company/tabs/aisettings/promo.vue'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Настройки ИИ, промо'
            },
        }, {
            path: '/(uk/|ru/)?/dashboard/company-manangment/ai/parks',
            name: 'CompanyAISettingsParks',
            component: () => import('../views/cabinet/company/tabs/aisettings/parks.vue'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Настройки ИИ, парки'
            },
        }, {
            path: '/(uk/|ru/)?/dashboard/company-manangment/ai/links',
            name: 'CompanyAISettingsLinks',
            component: () => import('../views/cabinet/company/tabs/aisettings/links.vue'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Настройки ИИ, ссылки'
            },
        },]
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ie/sigex/form',
        name: 'SigexForm',
        component: () => import('../views/cabinet/company/tabs/CompanyIe/SigexForm.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Настройки ИП, Sigex форма'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ie/sigex/form',
        name: 'SaparForm',
        component: () => import('../views/cabinet/company/tabs/CompanyIe/SaparForm.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Настройки Sapar форма'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ie/payda/form',
        name: 'PaydaForm',
        component: () => import('../views/cabinet/company/tabs/CompanyIe/PaydaForm.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Настройки ИП, Payda форма'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ie/contract/edit',
        name: 'ContractForm',
        component: () => import('../views/cabinet/company/tabs/CompanyIe/ContractForm.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Настройки ИП, Контракты'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/employee-contractor/form',
        name: 'CompanyEmployeeContractorForm',
        component: () => import('../views/cabinet/company/tabs/EmployeeContractor/Form.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Договор сотрудничества, форма шаблона'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/team-settings/edit',
        name: 'FormTeamSetting',
        component: () => import('../views/cabinet/company/form/TeamSetting'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/overdraft',
        name: 'Overdraft',
        component: () => import('../views/overdraft/Overdraft'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Овердрафт'
        },
        children: [{
            path: '',
            name: 'overdraft-new',
            component: () => import('../views/overdraft/tables/new'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Овердрафт'
            },
        }, {
            path: '/(uk/|ru/)?/overdraft/active',
            name: 'overdraft-active',
            component: () => import('../views/overdraft/tables/active'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Овердрафт'
            },
        }, {
            path: '/(uk/|ru/)?/overdraft/rejected',
            name: 'overdraft-rejected',
            component: () => import('../views/overdraft/tables/rejected'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Овердрафт'
            },
        }, {
            path: '/(uk/|ru/)?/overdraft/closed',
            name: 'overdraft-closed',
            component: () => import('../views/overdraft/tables/closed'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Овердрафт'
            },
        }, {
            path: '/(uk/|ru/)?/overdraft/suspended',
            name: 'overdraft-suspended',
            component: () => import('../views/overdraft/tables/suspended'),
            query: true,
            meta: {
                requiresAuth: true,
                title: 'Овердрафт'
            },
        }]
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/iron-parks',
        name: 'ironParks',
        component: () => import('../views/cabinet/company/tabs/ironParks'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Железные парки'
        }
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/park/edit',
        name: 'CompanyParkEdit',
        component: () => import('../views/cabinet/company/form/Park'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Парк'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/role/edit',
        name: 'CompanyRoleEdit',
        component: () => import('../views/cabinet/company/form/Role'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/user/edit',
        name: 'CompanyUserEdit',
        component: () => import('../views/cabinet/company/form/User'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/telephony/settings',
        name: 'CompanyUserTelephonySettings',
        component: () => import('../views/cabinet/company/form/TelephonySettings'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/ai/add-parks',
        name: 'aiParksAdd',
        component: () => import('../views/cabinet/company/tabs/aisettings/addParks.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Добавление парка'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/telephony/settings/edit',
        name: 'TelephonyRuleAdd',
        component: () => import('../views/cabinet/company/form/TelephonyRuleAdd'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/provider-service/edit',
        name: 'ServiceProviderEdit',
        component: () => import('../views/cabinet/company/form/ServiceProvider'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/department/edit',
        name: 'CompanyDepartmentEdit',
        component: () => import('../views/cabinet/company/form/Department'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/provider/edit',
        name: 'PaymentProvider',
        component: () => import('../views/cabinet/company/form/PaymentProvider'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/source-payment-provider/edit',
        name: 'SourcePaymentProvider',
        component: () => import('../views/cabinet/company/form/SourcePaymentProvider'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/chat-platform/edit',
        name: 'ChatPlatform',
        component: () => import('../views/cabinet/company/form/ChatPlatform'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/company-manangment/application-instance/edit',
        name: 'ApplicationInstanceform',
        component: () => import('../views/cabinet/company/form/ApplicationInstanceform'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление компанией'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/cabinet',
        name: 'Personal',
        component: () => import('../views/cabinet/personal/Personal'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Персональный кабинет'
        },
    }, {
        path: '',
        name: 'CallCenter',
        component: () => import('../views/cabinet/callcenter/CallCenter'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Управление кол центром'
        },
        children: [
            {
                path: '/(uk/|ru/)?/dashboard/cabinet/call-centger',
                name: 'PhrazeCategoriesList',
                component: () => import('../views/cabinet/callcenter/tabs/PhrazeCategoriesList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление кол центром'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/call-centger/phraze',
                name: 'PhrazeCategoriesPhrazeList',
                component: () => import('../views/cabinet/callcenter/tabs/PhrazeCategoriesPhrazeList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление кол центром - фразы'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/call-centger/statistic',
                name: 'StatisticList',
                component: () => import('../views/cabinet/callcenter/tabs/StatisticList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Управление кол центром'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/call-centger/operators',
                name: 'OperatorMonitoring',
                component: () => import('../views/cabinet/callcenter/tabs/operator-monitoring/Index'),
                meta: {
                    requiresAuth: true,
                    permission: 'operator_monitoring_view',
                    activeSideIcon: '#icon-chat',
                    title: 'Монитор операторов'
                },
            },
        ]
    }, {
        path: '',
        name: 'CabinetReports',
        component: () => import('../views/cabinet/reports/Main'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Отчеты'
        },
        children: [
            {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports',
                name: 'CabinetReportsDriverList',
                component: () => import('../views/cabinet/reports/tabs/Drivers'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Водители'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/detail',
                name: 'CabinetReportsDetail',
                component: () => import('../views/cabinet/reports/tabs/Detail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: детальнее водители'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/chats',
                component: () => import('../views/cabinet/reports/tabs/Chats'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: чаты'
                },
                children: [
                    {
                        path: '',
                        name: 'ChatsGeneral',
                        component: () => import('../views/cabinet/reports/tabs/chats/ChatsGeneral'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: чаты Общее'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/chats/category',
                        name: 'ChatsCategory',
                        component: () => import('../views/cabinet/reports/tabs/chats/ChatsCategory'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: чаты Категории'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/chats/department',
                        name: 'ChatsDepartment',
                        component: () => import('../views/cabinet/reports/tabs/chats/ChatsDepartment'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: чаты Департаменты'
                        },
                    }
                ]
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/chats/detail',
                name: 'CabinetReportsChatsDetail',
                component: () => import('../views/cabinet/reports/tabs/chats/ChatsDetail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: чаты'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/leeds',
                component: () => import('../views/cabinet/reports/tabs/Leeds'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лиды'
                },
                children: [
                    {
                        path: '',
                        name: 'LeedsGeneral',
                        component: () => import('../views/cabinet/reports/tabs/leeds/LeedsGeneral'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Лиды'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/leeds/source',
                        name: 'LeedsSource',
                        component: () => import('../views/cabinet/reports/tabs/leeds/LeedsSource'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Лиды Источники'
                        },
                    },
                ]
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/leeds/detail',
                name: 'CabinetReportsLeedsDetail',
                component: () => import('../views/cabinet/reports/tabs/leeds/LeedsDetail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лиды Детализация'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/leeds/source/detail',
                name: 'CabinetReportsLeedsSourceDetail',
                component: () => import('../views/cabinet/reports/tabs/leeds/LeedsSourceDetail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лиды Детализация'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/calls',
                component: () => import('../views/cabinet/reports/tabs/Calls'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Звонки'
                },
                children: [
                    {
                        path: '',
                        name: 'CallsGeneral',
                        component: () => import('../views/cabinet/reports/tabs/calls/CallsGeneral'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Звонки'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/calls/departments',
                        name: 'Callsdepartments',
                        component: () => import('../views/cabinet/reports/tabs/calls/CallsDepartments'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Звонки'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/calls/category',
                        name: 'CallsCategory',
                        component: () => import('../views/cabinet/reports/tabs/calls/CallsCategory'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Звонки'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/calls/statistic',
                        name: 'CallsStatistic',
                        component: () => import('../views/cabinet/reports/tabs/calls/CallsStatistic'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Звонки'
                        },
                    },
                ]
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/calls/detail',
                name: 'CabinetReportsCallsDetail',
                component: () => import('../views/cabinet/reports/tabs/calls/CallsDetail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Звонки Детализация'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/logs',
                name: 'CabinetReportsLogs',
                component: () => import('../views/cabinet/reports/tabs/Logs'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лог действий'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/apps',
                name: 'CabinetReportsApp',
                component: () => import('../views/cabinet/reports/tabs/apps'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лог действий'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/reports/ai',
                component: () => import('../views/cabinet/reports/tabs/ai'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Отчеты: Лог действий'
                },
                children: [
                    {
                        path: '',
                        name: 'botStatisticWorks',
                        component: () => import('../views/cabinet/reports/tabs/ai/botStatisticWorks'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Статистика по работе бота'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dashboard/cabinet/reports/ai/candidates-regions',
                        name: 'botCandidatesRegions',
                        component: () => import('../views/cabinet/reports/tabs/ai/botCandidatesRegions'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            title: 'Отчеты: Статистика по регистрациям бота'
                        },
                    },
                ]
            }
        ]
    }, {
        path: '',
        name: 'CabinetPayments',
        component: () => import('../views/cabinet/payments/System'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Вывод средств'
        },
        children: [
            {
                path: '/(uk/|ru/)?/dashboard/cabinet/payments',
                name: 'CabinetPaymentsList',
                component: () => import('../views/cabinet/payments/tabs/List'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Вывод средств'
                },
            }, {
                path: '/(uk/|ru/)?/dashboard/cabinet/payments/cards',
                name: 'CabinetPaymentsCardList',
                component: () => import('../views/cabinet/payments/tabs/CabinetPaymentsCardList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Вывод средств'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/dashboard/cabinet/summary-reports',
        name: 'SummarReportsDetail',
        component: () => import('../views/cabinet/summary/index.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Отчеты: Водители'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/cabinet/payments/create',
        name: 'PaymentCreate',
        component: () => import('../views/cabinet/payments/tabs/PaymentCreate'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Вывод средств'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/cabinet/payments/cards/create',
        name: 'PaymentCardsCreate',
        component: () => import('../views/cabinet/payments/tabs/PaymentCardsCreate'),
        query: true,
        meta: {
            requiresAuth: true,
            title: 'Вывод средств'
        },
    }, {
        path: '/(uk/|ru/)?/dashboard/cabinet/call-centger/fast-Phraze',
        name: 'AddFastPhraze',
        component: () => import('../views/cabinet/callcenter/tabs/AddFastPhraze'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Новая быстрая фраза'
        },
    },
]
